import { Grid, makeStyles } from '@material-ui/core'
import SelectInput from 'components/common/SelectInput'
import { PatientsListTypes } from 'consts/copilotControlConsts'
import useCopilotPatientsList from 'components/CopilotControl/hooks/useCopilotPatientsList'
import React from 'react'

const useStyles = makeStyles(() => ({
  titleContainer: {
    paddingLeft: 5,
    paddingBottom: 10
  },
  dropdown: {
    borderRadius: 16
  },
  selectOption: {
    fontSize: 15,
    padding: '10px 20px'
  }
}))

const PatientListTitle = () => {
  const classes = useStyles()

  const { selectedPatientsListType, handlePatientListTypeSelected } = useCopilotPatientsList()

  const titleOptions = Object.values(PatientsListTypes).map(type => ({
    label: type.title,
    value: type.type
  }))

  return (
    <Grid container justifyContent="flex-start" alignItems="center" className={classes.title}>
      <Grid item className={classes.titleContainer}>
        <SelectInput
          selectStyle={{ border: 'none', fontSize: 14, fontWeight: 500, marginTop: -2 }}
          showArrow={false}
          style={{ bright: true, thick: true }}
          value={selectedPatientsListType}
          options={titleOptions}
          keepErrorContainerWhenInactive={false}
          dropdownClassName={classes.dropdown}
          optionClassName={classes.selectOption}
          onChange={({ value }) => handlePatientListTypeSelected(value)}
        />
      </Grid>
    </Grid>
  )
}

export default PatientListTitle
